import styles from './DocumentsEmptyState.module.css'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { Button } from '@/components/Button'
import { FileButton } from '@/components/FileButton'
import { byDesign } from '@/infra/design'
import imgNojobstodisplayUrl from '@/assets/misc/img_nojobstodisplay.svg'
import NoJobsToDisplayIllustration from '@/components/SpotIllustration/NoJobsToDisplayIllustration'

export interface DocumentsEmptyStateProps {
  canUploadFiles: boolean
  currentWorkspaceEmpty: boolean
  currentWorkspaceName: string
  onSelectCurrentWorkspace: () => void
  onQueueFilesUpload: (files: FileList) => void
  corporateMode: boolean
}

export function DocumentsEmptyState({
  canUploadFiles,
  currentWorkspaceEmpty,
  currentWorkspaceName,
  onSelectCurrentWorkspace,
  onQueueFilesUpload,
  corporateMode,
}: DocumentsEmptyStateProps) {
  const illustration = !corporateMode && (
    <EmptyStateIllustration
      src={imgNojobstodisplayUrl}
      illustration={byDesign(undefined, NoJobsToDisplayIllustration)}
    />
  )
  return (
    <div className={styles.emptyStateContainer}>
      {currentWorkspaceEmpty ? (
        <EmptyState narrow>
          {illustration}
          <EmptyStateTitle>
            {canUploadFiles
              ? "You haven't uploaded any files yet"
              : "You don't have any files yet"}
          </EmptyStateTitle>
          <EmptyStateDescription>
            {canUploadFiles
              ? 'You can use this screen to upload images and documents for ease of access. Simply drag and drop or click Upload Files to get started'
              : 'Documents you upload from your jobs will show up here'}
          </EmptyStateDescription>
          {canUploadFiles && (
            <EmptyStateActions>
              <FileButton
                multiple={true}
                onChange={onQueueFilesUpload}
                data-test="upload-document-input-classic"
              >
                <Button label="Upload Files" variant="primary" />
              </FileButton>
            </EmptyStateActions>
          )}
        </EmptyState>
      ) : (
        <div className={styles.emptyStateContainer}>
          <EmptyState narrow>
            {illustration}
            <EmptyStateTitle>
              You don't have any files in any workspace!
            </EmptyStateTitle>
            <EmptyStateDescription>
              You can switch back to {currentWorkspaceName} and upload a file or
              select another workspace in the workspace switcher
            </EmptyStateDescription>
            <EmptyStateActions>
              <Button
                label={`View ${currentWorkspaceName} Documents`}
                onPress={onSelectCurrentWorkspace}
                variant="primary"
              />
            </EmptyStateActions>
          </EmptyState>
        </div>
      )}
    </div>
  )
}
